import { Container, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import useSEO from "../components/Shared/useSEO"

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
}))

export default function Impressum() {
  useSEO({ title: "Impressum" })
  const classes = useStyles()
  return (
    <Container maxWidth="md" className={classes.container}>
      <Typography variant="h2" gutterBottom>
        Impressum
      </Typography>
      <Typography variant="h5">
        Angaben gem&auml;&szlig; &sect; 5 TMG
      </Typography>
      {/* <Typography variant="body1" component="p">
        Vereinigte Turnerschaft Hagsfeld 1895 e.V.
        <br />
        Schäferstraße 26
        <br />
        76139 Karlsruhe-Hagsfeld
        <br />
        <strong>Vertreten durch:</strong>
        <br />
        Bernd G.Weber (Vorsitzender)
        <br />
        Andreas Bellm (stv. Vorsitzender)
        <br />
      </Typography>
      <br />

      <Typography variant="h5">Kontakt</Typography>
      <Typography variant="body1" component="p">
        Telefon: +49 7 21 / 68 81 10
        <br />
        Telefax: +49 7 21 / 9 68 34 79
        <br />
        Internet: www.vthagsfeld.de
      </Typography>
      <br /> */}

      <Typography variant="h5">Redaktionell Verantwortliche</Typography>
      <Typography variant="body1" component="p">
        Felix Stiegler
        <br />
        August-Schwall-Str. 1
        <br />
        76131 Karlsruhe
      </Typography>
      <br />

      <Typography variant="h5">
        Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
      </Typography>
      <Typography variant="body1" component="p">
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </Typography>
      <br />

      <Typography variant="h5">Haftung f&uuml;r Inhalte</Typography>
      <Typography variant="body1" component="p">
        Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG
        f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
        verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder
        gespeicherte fremde Informationen zu &uuml;berwachen oder nach
        Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit
        hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon
        unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem
        Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich.
        Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
        Inhalte umgehend entfernen.
      </Typography>
      <br />

      <Typography variant="h5">Haftung f&uuml;r Links</Typography>
      <Typography variant="body1" component="p">
        Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r
        diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r
        die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
        Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
        Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e
        &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der
        Verlinkung nicht erkennbar.
        <br />
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
        ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </Typography>
      <br />

      <Typography variant="h5">Urheberrecht</Typography>
      <Typography variant="body1" component="p">
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die
        Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der
        Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen
        der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht
        kommerziellen Gebrauch gestattet.
        <br />
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
        <br />
        Quelle:{" "}
        <a href="https://www.e-recht24.de" rel="noreferrer">
          https://www.e-recht24.de
        </a>
      </Typography>
    </Container>
  )
}
